import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import config from './config';
import sale from './sale';
import timeouts from './timeouts';
import inventory from './inventory';

const rootReducer = history =>
  combineReducers({
    config,
    timeouts,
    sale,
    inventory,
    router: connectRouter(history)
  });

export default rootReducer;
